export default __webpack_public_path__ + "../staticImages/facebook-icon.jpg";